export default __webpack_public_path__ + "static/media/Line 2.78806c3e.svg";